webpackJsonp([3],{

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_components_common_bootstrapvue_console_FormBlock_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormBlock: __WEBPACK_IMPORTED_MODULE_0__vue_components_common_bootstrapvue_console_FormBlock_vue__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        username: '',
        password: ''
      },
      working: false
    };
  },

  validators: {
    'form.username': function formUsername(value) {
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).required('必須');
    },
    'form.password': function formPassword(value) {
      return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(value).required('必須');
    }
  },
  methods: {
    login: function login() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$validate();

              case 2:
                result = _context.sent;

                if (result) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _this.working = true;
                _context.prev = 6;
                _context.next = 9;
                return _this.$http.post('/api/login', _this.form);

              case 9:
                window.location.href = '/console';
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (_context.t0.status === 400) {
                  _this.$utils.toast.warning('ユーザー名またはパスワードのエラー。');
                } else {
                  _this.$utils.handleGeneralError(_context.t0);
                }

              case 15:
                _context.prev = 15;

                _this.form.password = '';
                _this.validation.reset();
                _this.working = false;
                return _context.finish(15);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 12, 15, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
__webpack_require__(155);
module.exports = __webpack_require__(836);


/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_bootstrap__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_components_login_App_vue__ = __webpack_require__(837);






new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__vue_components_login_App_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e98fd0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(61);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e98fd0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27e98fd0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"layout-login login-form"},[_c('div',{staticClass:"login-title"},[_vm._v("\n      ログイン\n    ")]),_vm._v(" "),_c('form-block',[_c('b-form-group',{staticClass:"plain",attrs:{"label":"ユーザー名","invalid-feedback":_vm.validation.firstError('form.username'),"state":_vm.validation.hasError('form.username') ? 'invalid' : null}},[_c('b-form-input',{attrs:{"state":_vm.validation.hasError('form.username') ? 'invalid' : null},model:{value:(_vm.form.username),callback:function ($$v) {_vm.$set(_vm.form, "username", $$v)},expression:"form.username"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"plain",attrs:{"label":"パスワード","invalid-feedback":_vm.validation.firstError('form.password'),"state":_vm.validation.hasError('form.password') ? 'invalid' : null}},[_c('b-form-input',{attrs:{"state":_vm.validation.hasError('form.password') ? 'invalid' : null,"type":"password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"form.password"}})],1),_vm._v(" "),_c('b-button',{staticClass:"login-button",attrs:{"size":"lg","block":"","variant":"primary","disabled":_vm.working},on:{"click":function($event){_vm.login()}}},[_vm._v("ログイン")])],1)],1),_vm._v(" "),_c('div',{staticClass:"layout-login-footer"},[_vm._v("Copyright (c) 2018-2019 LinkJapan All Rights Reserved.")])])}
var staticRenderFns = []


/***/ })

},[835]);


// WEBPACK FOOTER //
// login.js